export const normalizeBrandOrModel = (name) => {
  return name && name.toString().split(' ').join('_').toLowerCase();
};
